import React from 'react';
import { IIcon } from '../../@types/icons';
import { defaultTheme } from '../../styles/theme/default';

const SPEAKER_PATHS = [
    'M4.5 7.5H2.25C1.85218 7.5 1.47064 7.65804 1.18934 7.93934C0.908035 8.22064 0.75 8.60218 0.75 9V12C0.75 12.3978 0.908035 12.7794 1.18934 13.0607C1.47064 13.342 1.85218 13.5 2.25 13.5H4.5V7.5Z',
    'M4.5 13.4991L10.365 17.7141C10.5823 17.8644 10.8355 17.9547 11.0989 17.9758C11.3623 17.9968 11.6266 17.948 11.865 17.8341C12.1236 17.7179 12.344 17.5308 12.5006 17.2946C12.6572 17.0583 12.7437 16.7825 12.75 16.4991V4.49906C12.7564 4.22969 12.6902 3.96356 12.5582 3.72865C12.4262 3.49373 12.2334 3.29871 12 3.16406C11.7616 3.05017 11.4973 3.00128 11.2339 3.02236C10.9705 3.04343 10.7173 3.13371 10.5 3.28406L4.5 7.49906',
];

const LOCK_PATHS = [
    'M14.25 8.25H19.75C20.11 8.25 20.4 8.54 20.4 8.9V12.1C20.4 12.46 20.11 12.75 19.75 12.75H14.25C13.89 12.75 13.6 12.46 13.6 12.1V8.9C13.6 8.54 13.89 8.25 14.25 8.25Z',
    'M15.25 8.25V7.2C15.25 6.2 16.05 5.4 17 5.4C17.95 5.4 18.75 6.2 18.75 7.2V8.25',
];

export function AudioLocked ({ size = 21, strokeColor = 'battleShipGray' }: IIcon) {
    const color = strokeColor
        ? defaultTheme.colors[strokeColor] || strokeColor
        : defaultTheme.colors.battleShipGray;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            viewBox="0 0 21 21"
        >
            {SPEAKER_PATHS.map((speakerPath) => (
                <path
                    key={speakerPath}
                    d={speakerPath}
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ))}
            {LOCK_PATHS.map((speakerPath) => (
                <path
                    key={speakerPath}
                    d={speakerPath}
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ))}
        </svg>
    );
}
